import axios from 'axios';
import authHeader from './auth-header';
import { apiUrl } from '../constant';

const API_URL = apiUrl;

class DashboardPreferenceService {
    /**
     * Fetch the default saved dashboard preference for the logged-in user.
     * Returns null if none exists.
     */
    getDefault() {
        return axios.get(
            `${API_URL}/api/DashboardPreference/GetDefault`,
            { headers: authHeader() }
        );
    }

    /**
     * Fetch all saved dashboard presets for the logged-in user.
     */
    getAll() {
        return axios.get(
            `${API_URL}/api/DashboardPreference/GetAll`,
            { headers: authHeader() }
        );
    }

    /**
     * Save (upsert) a dashboard preference.
     * @param {Object} payload - { name, filtersJson, isDefault }
     */
    save(payload) {
        return axios.post(
            `${API_URL}/api/DashboardPreference/Save`,
            payload,
            { headers: authHeader() }
        );
    }

    /**
     * Delete a saved preference by ID.
     * @param {number} id
     */
    remove(id) {
        return axios.delete(
            `${API_URL}/api/DashboardPreference/${id}`,
            { headers: authHeader() }
        );
    }
}

export default new DashboardPreferenceService();
